import React from 'react';
import { Modal } from 'react-bootstrap';

export default function HelpMeasureModalPleated({
  pageLanguage,
  modals,
  modalHandleClose,
  setHelpMeasure,
  setHelpMeasureLengthType,
  helpMeasure,
  helpMeasureLengthType,
  step3A0,
  t,
}) {
  return (
   <Modal
       backdrop="static"
       keyboard={false}
       dialogClassName={`measurementsHelp_modal largeSizeModal scroll_on ${
         pageLanguage === "fa" ? "font_farsi" : "font_en"
       }`}
       show={modals["measurementsHelp"] === undefined ? false : modals["measurementsHelp"]}
       onHide={() => {
         modalHandleClose("measurementsHelp");
         setTimeout(() => {
           setHelpMeasure("hasRod");
           setHelpMeasureLengthType("Floor");
         }, 300);
       }}
       scrollable={true}
     >
       <Modal.Header closeButton></Modal.Header>
       <Modal.Body>
         <p className="measurementsHelp_modal_title measurementsHelp_modal_title_desktop">{t("HOW_TO_PLEATED_DRAPERY")}</p>
         <p className="measurementsHelp_modal_title measurementsHelp_modal_title_mobile">{t("HOW_TO_PLEATED_DRAPERY_MOBILE")}</p>
         <div className="help_options_container">
           <ul className="help_options">
             <li
               className={`help_option_item ${
                 helpMeasure === "hasRod" ? "help_option_item_on" : ""
               }`}
               onClick={() => setHelpMeasure("hasRod")}
             >
               {t("bold_help_hasRod")}
             </li>
             <li className="help_option_item_separator"></li>
             <li
               className={`help_option_item ${
                 helpMeasure === "HasTrack" ? "help_option_item_on" : ""
               }`}
               onClick={() => setHelpMeasure("HasTrack")}
             >
               {t("bold_help_track")}
             </li>
             <li className="help_option_item_separator"></li>
             <li
               className={`help_option_item help_option_item_desktop ${
                 helpMeasure === "noRod" ? "help_option_item_on" : ""
               }`}
               onClick={() => setHelpMeasure("noRod")}
             >
               {t("bold_help_noHar")}
             </li>
             <li
               className={`help_option_item help_option_item_mobile ${
                 helpMeasure === "noRod" ? "help_option_item_on" : ""
               }`}
               onClick={() => setHelpMeasure("noRod")}
             >
               {t("bold_noHar")}
             </li>
           </ul>
         </div>

         {step3A0 === "Wall" && (
           <>
             {helpMeasure === "hasRod" && (
               <div>
                 <div className="measurementsHelp_modal_img_section">
                   <object
                     className="measurementsHelp_modal_img"
                     type="image/svg+xml"
                     data={
                       pageLanguage === "fa"
                         ? require("../../Images/drapery/grommet/help_hasRod_fa.svg").default
                         : require("../../Images/drapery/grommet/has_rod_new2.svg").default
                     }
                   />
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_modal_help_1")}</li>
                         <li className="help_or">{t("OR")}</li>
                         <li>{t("pleated_modal_help_2")}</li>
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
             {helpMeasure === "HasTrack" && (
               <div>
                 <div className="measurementsHelp_modal_img_section">
                   <object
                     className="measurementsHelp_modal_img"
                     type="image/svg+xml"
                     data={
                       pageLanguage === "fa"
                         ? require("../../Images/drapery/grommet/help_noRod_fa.svg").default
                         : require("../../Images/drapery/european/measurmendk-track.svg").default
                     }
                   />
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_track_has_wall_modal_help_4")}</li>
                         <li className="help_or">{t("OR")}</li>
                         <li>{t("pleated_track_has_wall_modal_help_5")}</li>
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated2_track_has_wall_modal_help_6")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
             {helpMeasure === "noRod" && (
               <div>
                 <div className="measurementsHelp_modal_img_section">
                   <object
                     className="measurementsHelp_modal_img"
                     type="image/svg+xml"
                     data={
                       pageLanguage === "fa"
                         ? require("../../Images/drapery/grommet/help_noRod_fa.svg").default
                         : require("../../Images/drapery/grommet/help_noRod.svg").default
                     }
                   />
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_wall_modal_help_4")}</li>
                         <li className="help_or">{t("OR")}</li>
                         <li style={{fontSize: "0.9275rem"}}>{t("grommet_modal_help_5")}</li>
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_wall_modal_help_6")}</li>
                         <li>{t("grommet_modal_help_wall_1")}</li>
                         <li>{t("grommet_modal_help_wall_2")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
           </>
         )}

         {step3A0 === "Ceiling" && (
           <>
             {helpMeasure === "hasRod" && (
               <div>
                 <br />
                 <div className="help_options_container help_options_container_mobile">
                   <ul className="help_options help_options_lengthType help_options help_options_lengthType2">
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Floor")}
                     >
                       {t("help_FLOOR")}
                     </li>
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Sill")}
                     >
                       {t("help_SILL/APRON")}
                     </li>
                   </ul>
                 </div>
                 <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                   {helpMeasureLengthType === "Sill" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/grommet/help_new_ceiling_to_window_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/grommet/help_new_ceiling_to_window_3.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                   {helpMeasureLengthType === "Floor" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/grommet/help_new_ceiling_to_floor_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/grommet/help_new_ceiling_to_floor_3.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                   <div className="accordion_help measurementsHelp_modal_help_section
                 measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list 22">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("pleated_ceiling_rod_modal_help_2_new")}
                           </li>
                           
                         )}
                         
                       </ul>
                     </div>
                   </div>
                 </div>
                   <span>
                     <object
                       className="measurementsHelp_modal_img"
                       type="image/svg+xml"
                       data={
                         pageLanguage === "fa"
                           ? require("../../Images/drapery/grommet/help_new_FrameSize_ceiling_fa.svg")
                               .default
                           : require("../../Images/drapery/grommet/help_new_FrameSize_ceiling.svg")
                               .default
                       }
                     />
                   </span>
                   <div className="accordion_help measurementsHelp_modal_help_section
                 measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                   

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section
                 measurementsHelp_modal_help_section_desktop">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list 23">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                            <>
                            <li>
                              <b>{t("Sill/Apron:&nbsp;")}</b>
                              {t("pleated_ceiling_rod_modal_help_2_new")}
                            </li>
                            {pageLanguage === "fa" && (
                           <>
                               <li>
                               {t("pleated_ceiling_rod_modal_help_2_new_fa")}
                             </li>
                             <li>
                               {t("pleated_ceiling_rod_modal_help_1_new_fa")}
                             </li>
                           </>
                            )}
                           </>
                         )}
                         
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
             {helpMeasure === "noRod" && (
               <div>
                 <br />
                 <div className="help_options_container help_options_container_mobile">
                   <ul className="help_options help_options_lengthType help_options help_options_lengthType2">
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Floor")}
                     >
                       {t("help_FLOOR")}
                     </li>
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Sill")}
                     >
                       {t("help_SILL/APRON")}
                     </li>
                   </ul>
                 </div>
                 <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                   {helpMeasureLengthType === "Sill" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/dk/help_new_ceiling_to_window_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/dk/help_new_ceiling_to_window_3.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                   {helpMeasureLengthType === "Floor" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/dk/help_new_ceiling_to_floor_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/dk/help_new_ceiling_to_floor_3.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                    <div className="accordion_help measurementsHelp_modal_help_section
                 measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT TO")}</p>
                       <ul className="help_column_list 24">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_2")}
                           </li>
                         )}
                       </ul>
                     </div>

                   
                   </div>
                 </div>
                   <span>
                     <object
                       className="measurementsHelp_modal_img"
                       type="image/svg+xml"
                       data={
                         pageLanguage === "fa"
                           ? require("../../Images/drapery/dk/help_new_FrameSize.svg").default
                           : require("../../Images/drapery/dk/help_new_FrameSize.svg").default
                       }
                     />
                   </span>
                   <div className="accordion_help measurementsHelp_modal_help_section
                 measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                 

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_ceiling_modal_help_3")}</li>
                         <li>{t("grommet_modal_help_wall_1")}</li>
                         <li>{t("grommet_modal_help_wall_2")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section
                 measurementsHelp_modal_help_section_desktop">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT TO")}</p>
                       <ul className="help_column_list 25">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_2")}
                           
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_1")}
                           </li>
                         )}
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_ceiling_modal_help_3")}</li>
                         <li>{t("grommet_modal_help_wall_1")}</li>
                         <li>{t("grommet_modal_help_wall_2")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
              {helpMeasure === "HasTrack" && (
               <div>
                 <br />
                 <div className="help_options_container help_options_container_mobile">
                   <ul className="help_options help_options_lengthType help_options help_options_lengthType2">
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Floor")}
                     >
                       {t("help_FLOOR")}
                     </li>
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Sill")}
                     >
                       {t("help_SILL/APRON")}
                     </li>
                   </ul>
                 </div>
                 <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                   {helpMeasureLengthType === "Sill" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/dk/help_new_ceiling_to_window_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/dk/help_new_ceiling_to_window_3.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                   {helpMeasureLengthType === "Floor" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/dk/help_new_ceiling_to_floor_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/european/tf1.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                    <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT TO")}</p>
                       <ul className="help_column_list 26">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_")}
                           </li>
                         )}
                       </ul>
                     </div>

                    
                   </div>
                 </div>
                   <span>
                     <object
                       className="measurementsHelp_modal_img"
                       type="image/svg+xml"
                       data={
                         pageLanguage === "fa"
                           ? require("../../Images/drapery/dk/help_new_FrameSize.svg").default
                           : require("../../Images/drapery/european/t1.svg").default
                       }
                     />
                   </span>
                   <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                   

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_hasTrack_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_desktop">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT TO")}</p>
                       <ul className="help_column_list 27">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                         <>
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_4")}
                           </li>
                           {pageLanguage === "fa" && (
                           <>
                               <li>
                               {t("pleated_hasTrack_ceiling_rod_modal_help_4_fa")}
                             </li>
                             <li>
                               {t("pleated_hasTrack_ceiling_rod_modal_help_4_fa_2")}
                             </li>
                           </>
                            )}
                         </>
                         )}
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_hasTrack_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
           </>
         )}
         {step3A0 === "Moulding" && (
           <>
             {helpMeasure === "hasRod" && (
               <div>
                 <br />
                 <div className="help_options_container help_options_container_mobile">
                   <ul className="help_options help_options_lengthType help_options help_options_lengthType2">
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Floor")}
                     >
                       {t("help_FLOOR")}
                     </li>
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Sill")}
                     >
                       {t("help_SILL/APRON")}
                     </li>
                   </ul>
                 </div>
                 <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                   {helpMeasureLengthType === "Sill" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/grommet/help_new_ceiling_to_window_3_arc_fa.svg")
                                 .default
                             : require("../../Images/drapery/grommet/help_new_ceiling_to_window_3_arc.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                   {helpMeasureLengthType === "Floor" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/grommet/help_new_ceiling_to_floor_3_arc_fa.svg")
                                 .default
                             : require("../../Images/drapery/grommet/help_new_ceiling_to_floor_3_arc.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                    <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list 28">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("pleated_ceiling_rod_modal_help_2")}
                           </li>
                         )}
                       </ul>
                     </div>

                   </div>
                 </div>
                   <span>
                     <object
                       className="measurementsHelp_modal_img"
                       type="image/svg+xml"
                       data={
                         pageLanguage === "fa"
                           ? require("../../Images/drapery/grommet/help_new_FrameSize_arc_fa.svg")
                               .default
                           : require("../../Images/drapery/grommet/help_new_FrameSize_arc.svg")
                               .default
                       }
                     />
                   </span>
                   <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                   
                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_desktop">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list 29">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("pleated_ceiling_rod_modal_help_2")}
                           </li>
                         )}
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
             {helpMeasure === "noRod" && (
               <div>
                 <br />
                 <div className="help_options_container help_options_container_mobile">
                   <ul className="help_options help_options_lengthType help_options help_options_lengthType2">
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Floor")}
                     >
                       {t("help_FLOOR")}
                     </li>
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Sill")}
                     >
                       {t("help_SILL/APRON")}
                     </li>
                   </ul>
                 </div>
                 <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                   {helpMeasureLengthType === "Sill" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/grommet/help_new_ceiling_to_window_3_arc_noRod_fa.svg")
                                 .default
                             : require("../../Images/drapery/grommet/help_new_ceiling_to_window_3_arc_noRod.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                   {helpMeasureLengthType === "Floor" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/grommet/help_new_ceiling_to_floor_3_arc_noRod_fa.svg")
                                 .default
                             : require("../../Images/drapery/grommet/help_new_ceiling_to_floor_3_arc_noRod.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                    <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list 30">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_2")}
                           </li>
                         )}
                       </ul>
                     </div>

                    
                   </div>
                 </div>
                   <span>
                     <object
                       className="measurementsHelp_modal_img"
                       type="image/svg+xml"
                       data={
                         pageLanguage === "fa"
                           ? require("../../Images/drapery/dk/help_new_FrameSize.svg").default
                           : require("../../Images/drapery/dk/help_new_FrameSize.svg").default
                       }
                     />
                   </span>
                   <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_ceiling_modal_help_3")}</li>
                         <li>{t("grommet_modal_help_wall_1")}</li>
                         <li>{t("grommet_modal_help_wall_2")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_desktop">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT")}</p>
                       <ul className="help_column_list 31">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("grommet_ceiling_modal_help_2")}
                           </li>
                         )}
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("grommet_ceiling_modal_help_3")}</li>
                         <li>{t("grommet_modal_help_wall_1")}</li>
                         <li>{t("grommet_modal_help_wall_2")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
              {helpMeasure === "HasTrack" && (
               <div>
                 <br />
                 <div className="help_options_container help_options_container_mobile">
                   <ul className="help_options help_options_lengthType help_options help_options_lengthType2">
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Floor" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Floor")}
                     >
                       {t("help_FLOOR")}
                     </li>
                     <li
                       className={`help_option_lengthType_item ${
                         helpMeasureLengthType === "Sill" ? "help_option_lengthType_item_on" : ""
                       }`}
                       onClick={() => setHelpMeasureLengthType("Sill")}
                     >
                       {t("help_SILL/APRON")}
                     </li>
                   </ul>
                 </div>
                 <div className="measurementsHelp_modal_img_section dk_measurementsHelp_modal_img_section">
                   {helpMeasureLengthType === "Sill" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/dk/help_new_ceiling_to_window_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/dk/help_new_ceiling_to_window_3.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                   {helpMeasureLengthType === "Floor" && (
                     <span>
                       <object
                         className="measurementsHelp_modal_img"
                         type="image/svg+xml"
                         data={
                           pageLanguage === "fa"
                             ? require("../../Images/drapery/dk/help_new_ceiling_to_floor_3_fa.svg")
                                 .default
                             : require("../../Images/drapery/dk/help_new_ceiling_to_floor_3.svg")
                                 .default
                         }
                       />
                     </span>
                   )}
                    <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT TO")}</p>
                       <ul className="help_column_list 32">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_2")}
                           </li>
                         )}
                       </ul>
                     </div>
                   </div>
                 </div>
                   <span>
                     <object
                       className="measurementsHelp_modal_img"
                       type="image/svg+xml"
                       data={
                         pageLanguage === "fa"
                           ? require("../../Images/drapery/dk/help_new_FrameSize.svg").default
                           : require("../../Images/drapery/dk/help_new_FrameSize.svg").default
                       }
                     />
                   </span>
                   <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_mobile">
                   <div className="help_container">
                   
                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_hasTrack_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
                 </div>
                 <div className="accordion_help measurementsHelp_modal_help_section measurementsHelp_modal_help_section_desktop">
                   <div className="help_container">
                     <div className="help_column help_left_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL HEIGHT TO")}</p>
                       <ul className="help_column_list 33">
                         {helpMeasureLengthType === "Floor" && (
                           <li>
                             <b>{t("Floor:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_1")}
                           </li>
                         )}
                         {helpMeasureLengthType === "Sill" && (
                           <li>
                             <b>{t("Sill/Apron:&nbsp;")}</b>
                             {t("pleated_hasTrack_ceiling_rod_modal_help_2")}
                           </li>
                         )}
                       </ul>
                     </div>

                     <div className="help_column help_right_column">
                       <p className="help_column_header">{t("TO DETERMINE PANEL WIDTH")}</p>
                       <ul className="help_column_list">
                         <li>{t("pleated_hasTrack_modal_help_3")}</li>
                       </ul>
                     </div>
                   </div>
                 </div>
               </div>
             )}
           </>
         )}
         <br />
         <div className="text_center">
           <button
             className="btn btn-new-dark"
             onClick={() => {
               modalHandleClose("measurementsHelp");
               setTimeout(() => {
                 setHelpMeasure("hasRod");
                 setHelpMeasureLengthType("Floor");
               }, 300);
             }}
           >
             {t("CONTINUE")}
           </button>
         </div>
       </Modal.Body>
     </Modal>
  )
}
